import { debounce } from "lodash-es";

export default class BackToTop {
    constructor() {
        this.threshold = 500; // px

        this.button = document.querySelector(".back-to-top");

        window.addEventListener(
            "scroll",
            debounce(
                e => {
                    this.toggle();
                },
                16,
                { leading: true, trailing: true }
            )
        );
    }
    toggle() {
        this.button.hidden = window.scrollY < this.threshold;
    }
}
